const getLangTag = (subtitles) => subtitles.lang_tag;
const isLangStartWith = (startWith) => (subtitles) => subtitles.find((subtitle) => getLangTag(subtitle).startsWith(startWith));
const getFirst = (collection) => collection[0];
const getPredicates = (langList) => {
  const predicates = langList.map(lang => isLangStartWith(lang));
  return predicates.concat(getFirst);
};

/**
 * Return subtitle matched to one of lang in list, if failure - fallback to first subtitle: "off".
 * @function
 * @template T
 * @param {T[]} options
 * @param {string[]} langList
 * @return {T}
 */
export function getMatchedOrFirst(options, langList) {
  const predicates = getPredicates(langList.filter(Boolean));
  for (let i = 0; i < predicates.length; i++) {
    const predicate = predicates[i];
    const result = predicate(options);
    if (result) {
      return result;
    }
  }
}
